module.exports = __webpack_public_path__ + "static/UIIcons-83247a7303cb15ab221ca1d6dab01cbe.jpg";